import React from 'react';

interface DislikeFullProps {
  styles?: React.CSSProperties;
}

export const DislikeFull: React.FC<DislikeFullProps> = ({ styles: _styles }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
      <rect width="256" height="256" fill="none"></rect>
      <path d="M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56A8,8,0,0,1,32,48Z" fill="white" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8"></path>
      <path d="M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80" fill="white" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8"></path>
    </svg>
  );
};
